
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import Isotope from 'isotope-layout';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();

    jarallaxVideo();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    var swiper = new Swiper(".carousel", {
        loop: true,
        autoplay: {
            delay: 5000
        },
        speed: 2000,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        }
    });

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= $('#contact-navigation').outerHeight()) {
            $('body').addClass('navbar-fixed');
        } else {
            $('body').removeClass('navbar-fixed');
        }
    });

    setTimeout(() => {
        var container = document.querySelector('.staff-tiles');
        if(container) {
            var iso = new Isotope( container, {
                itemSelector: '.staff-tile',
                layoutMode: 'fitRows'
            });
            var filters = $('#filters').on( 'click', '.button', function() {
                var $this = $( this );
                var filterValue;
                if ( $this.is('.is-checked') ) {
                    // uncheck
                    filterValue = '*';
                } else {
                    filterValue = $this.attr('data-filter');
                    filters.find('.is-checked').removeClass('is-checked');
                }
                $this.toggleClass('is-checked');
                // use filterFn if matches value
                iso.arrange({ filter: filterValue });
            });
        }
    }, 700);



    var swiper = new Swiper(".hail-swiper", {
        loop: true,
        breakpoints: {
            767: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 40,
            }
        },
        navigation: {
            nextEl: ".arrow-right",
            prevEl: ".arrow-left",
        },
    });
    


    // $('.elemental-sponsors .slick').slick({
    //     slidesToShow: 5,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 5
    //             }
    //         },
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 4
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 2
    //             }
    //         }
    //     ]
    // });

    // $('.hail-carousel').each(function(index, element){
    //     //Build carousel options (from the Hail carousel DataObject)
    //     const slickOptions = {
    //         lazyLoad: 'ondemand',
    //         dots: ($(element).data('showdots') === "Yes"),
    //         slidesToShow: $(element).data('lg-toshow'),
    //         slidesToScroll: $(element).data('lg-toscroll'),
    //         responsive: [
    //             {
    //                 breakpoint: $(element).data('md-break'),
    //                 settings: {
    //                     slidesToShow: $(element).data('md-toshow'),
    //                     slidesToScroll: $(element).data('md-toscroll')
    //                 }
    //             },
    //             {
    //                 breakpoint: $(element).data('sm-break'),
    //                 settings: {
    //                     slidesToShow: $(element).data('sm-toshow'),
    //                     slidesToScroll: $(element).data('sm-toscroll'),
    //                     arrows: false
    //                 }
    //             }
    //         ]
    //     };

    //     $(element).slick(slickOptions);
    // });

});
